import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";

export async function DeleteModeloVehiculoAction (
    ModeloId: string
): Promise<ApiResponse<ModelosVehiculoInterface>> {
   const {data} = await apiClient.delete(`gvModeloVehiculos/${ModeloId}`);
    return {
        status: 200,
        data,
        message: "Modelo de vehiculo eliminado correctamente",
    };
}
    